<template>
  <svg
    class="check-icon"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
  >
    <path d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z" />
  </svg>
</template>

<script>
export default {
  name: "OperationReportCheckIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.check-icon {
  path {
    fill: $aisea-pure-white;
  }
}
</style>
